import React, { Component } from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

import { StyledWrapperTimes, StyledKeyBoardDatePicker } from './style';

class InputDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: null
    };
  }

  handleDateChange = selectedDate => {
    const { onChange, format } = this.props;
    this.setState({
      selectedDate
    });
    onChange(moment(selectedDate).format(format || 'DD-MM-YYYY'));
  };

  render() {
    const { selectedDate } = this.state;
    const {
      className,
      id,
      placeholder,
      max,
      min,
      format,
      icon,
      small,
      clearDate,
      value
    } = this.props;
    return (
      <StyledWrapperTimes small={small} className={className}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <StyledKeyBoardDatePicker
            id={id}
            format={format || 'DD-MM-YYYY'}
            value={clearDate ? null : selectedDate || value || null}
            onChange={this.handleDateChange}
            okLabel="Aceptar"
            cancelLabel="Cancelar"
            todayLabel="Hoy"
            placeholder={placeholder || ''}
            maxDate={max}
            minDate={min}
            keyboardIcon={icon || undefined}
          />
        </MuiPickersUtilsProvider>
      </StyledWrapperTimes>
    );
  }
}

export default InputDate;
